import { Item } from '@/api';
import { createContext } from 'react';

export type ItemContextType = { item: Item | undefined, refetch: () => void | undefined };

const ItemContext = createContext<ItemContextType>({
    item: undefined,
    refetch: () => {}
});

export default ItemContext;
